module.exports = __webpack_public_path__ + "img/118.3be1f411.jpg";